import React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';

function Footer() {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
        textAlign: 'center',
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {'© '}
        {new Date().getFullYear()}
        {' ERA Project tous droits réservés. '}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Produit de{' '}
        <Link color="inherit" href="https://groupeoctal.com" target="_blank" rel="noopener noreferrer">
          Octal Group LLC
        </Link>
      </Typography>
    </Box>
  );
}

export default Footer;
